<div *ngIf="switchAccountSpinner" [ngClass]="{ 'account-loading': switchAccountSpinner }"></div>
<ul *ngIf="showNavigation">
  <ng-container *ngIf="currentAccount?.kind !== 'grow' && !isCIActive; else alternativeNavigation">
    <li class="navbar__item" *ngIf="currentAccount?.step_status === 5" [class.active]="isActive('/reports')" (click)="goTo('/reports/dashboard')">
      {{ 'nav.performance' | translate }}
    </li>
    <li class="navbar__item" [class.active]="isActive('/strategy')" (click)="goTo('/strategy')">
      {{ 'nav.strategy' | translate }}
    </li>
    <li
      class="navbar__item"
      *ngIf="currentAccount?.step_status === 5"
      [class.active]="isActive('/adjust-investment')"
      (click)="goTo('/adjust-investment')"
    >
      {{ 'nav.adjust-investment' | translate }}
    </li>
    <li *ngIf="currentAccount?.step_status === 5 && !customer.inyova_pro">
      <button (click)="goTo('/tell-friend'); trackActivity('[Button] Invite friends from navigation button')" class="ui-button secondary fit-width">
        <span class="icon-i-people"></span>{{ 'nav.tell_friend' | translate }}
      </button>
    </li>
  </ng-container>
  <ng-template #alternativeNavigation>
    <ng-template *ngIf="!isCIActive; else CImenu">
      <li class="navbar__item" *ngIf="currentAccount?.step_status === 1" [class.active]="isActive('/grow')" (click)="goTo('/grow')">
        {{ 'strategy.overview' | translate }}
      </li>
    </ng-template>
    <ng-template #CImenu>
      <li class="navbar__item" [class.active]="isActive('/ci-overview')" (click)="goTo('/ci-overview')">
        {{ 'strategy.overview' | translate }}
      </li>
    </ng-template>
  </ng-template>
</ul>
<ul class="menu-right">
  <li
    *ngIf="showNavigation"
    class="navbar__item navbar__item--dropdown no-hover"
    (mouseover)="!switchAccountSpinner ? (switchAccountOpened = true) : (switchAccountOpened = false)"
    (mouseleave)="switchAccountOpened = false"
  >
    <div
      *ngIf="customer.app_location === 'ch'"
      class="account-switch"
      [ngClass]="{ disabled: switchAccountSpinner }"
      (click)="checkWasChanged()"
    >
      <ng-container *ngIf="currentAccount?.kind === '3a' && !isCIActive">
        <span class="icon-i-forest"></span> {{ 'productSwitchDropdown.3aAccount' | translate }}
      </ng-container>
      <ng-container *ngIf="currentAccount?.kind === 'grow' && !isCIActive && !customer.inyova_pro">
        <span class="icon-i-world"></span> {{ 'productSwitchDropdown.sectionTitle.grow' | translate }}
      </ng-container>
      <ng-container *ngIf="currentAccount?.kind === '3b' && !isCIActive">
        <span class="icon-i-tree"></span> {{ 'productSwitchDropdown.3bAccount' | translate }}
      </ng-container>
      <ng-container *ngIf="currentAccount?.kind === 'kid' && !isCIActive">
        <span class="icon-i-sprout"></span> {{ currentAccount?.owner_name }}
      </ng-container>
      <ng-container *ngIf="isCIActive">
        <span class="icon-i-windmill"></span>
        {{ 'productSwitchDropdown.sectionTitle.CI' | translate }}
      </ng-container>
      <span [ngClass]="!switchAccountSpinner && switchAccountOpened ? 'icon-i-chevron-up' : 'icon-i-chevron-down'"></span>
    </div>
    <div class="more-options desktop-dropdown" *ngIf="!switchAccountSpinner">
      <div *ngIf="customer.app_location === 'ch'">
        <h4>{{ 'productSwitchDropdown.sectionTitle.3a' | translate }}</h4>
        <a *ngIf="hasAccount('3a')" (click)="switchAccount(findCustomerAccount('3a'))" [class.active]="currentAccount?.kind === '3a' && !isCIActive">
          <span class="icon-i-forest"></span>
          {{ 'productSwitchDropdown.3aAccount' | translate }}
        </a>
        <a
          *ngIf="!hasAccount('3a')"
          class="add-account"
          (click)="customer.temporary_accounts.length ? goTo('/new-account/3a') : createNewAccount('3a')"
        >
          <span class="icon-i-plus-circle"></span>
          {{ 'productSwitchDropdown.new3aAccount' | translate }}
        </a>
      </div>
      <div *ngIf="customer.app_location === 'ch' && !customer.inyova_pro">
        <h4>{{ 'productSwitchDropdown.sectionTitle.grow' | translate }}</h4>
        <a
          *ngIf="hasAccount('grow')"
          (click)="switchAccount(findCustomerAccount('grow'))"
          [class.active]="currentAccount?.kind === 'grow' && !isCIActive"
        >
          <span class="icon-i-world"></span>
          {{ 'productSwitchDropdown.sectionTitle.grow' | translate }}
        </a>
        <a *ngIf="!hasAccount('grow')" class="add-account" (click)="goTo('/grow/intro')">
          <span class="icon-i-plus-circle"></span>
          {{ 'productSwitchDropdown.new3bAccount' | translate }}
        </a>
      </div>
      <div>
        <h4>{{ 'productSwitchDropdown.sectionTitle.3b' | translate }}</h4>
        <a *ngIf="hasAccount('3b')" (click)="switchAccount(findCustomerAccount('3b'))" [class.active]="currentAccount?.kind === '3b' && !isCIActive">
          <span class="icon-i-tree"></span>
          {{ 'productSwitchDropdown.3bAccount' | translate }}
        </a>
        <a
          *ngIf="!hasAccount('3b')"
          (click)="customer.app_location === 'ch' && customer.temporary_accounts.length ? goTo('/new-account/3b') : createNewAccount('3b')"
          class="add-account"
        >
          <span class="icon-i-plus-circle"></span>
          {{ 'productSwitchDropdown.new3bAccount' | translate }}
        </a>
      </div>
      <div *ngIf="customer.app_location === 'ch' && hasAccount('3b')">
        <h4>{{ 'productSwitchDropdown.sectionTitle.i4k' | translate }}</h4>
        <ng-container *ngIf="kidsAccounts?.length > 0">
          <a
            *ngFor="let kidAccount of kidsAccounts"
            (click)="switchAccount(kidAccount)"
            [class.active]="currentAccount?.id === kidAccount.id && !isCIActive"
            ><span class="icon-i-sprout"></span>{{ kidAccount.owner_name }}</a
          >
        </ng-container>
        <a class="add-account" (click)="createKidsAccount()">
          <span class="icon-i-plus-circle"></span>
          {{ 'productSwitchDropdown.newKidsAccount' | translate }}
        </a>
      </div>
      <div *ngIf="customer.has_crowd_investor_account">
        <h4>{{ 'productSwitchDropdown.sectionTitle.CI' | translate }}</h4>
        <a (click)="switchCIAccount()" [class.active]="isActive('/ci-overview')">
          <span class="icon-i-windmill"></span>
          {{ 'productSwitchDropdown.sectionTitle.CI' | translate }}
        </a>
      </div>
    </div>
  </li>
  <li class="navbar__item navbar__item--dropdown no-hover">
    <div class="navbar-hamburger">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <div class="more-options">
      <div>
        <h4>{{ customer.first_name }} {{ customer.last_name }}</h4>
        <a (click)="goTo('/profile/settings')" [class.active]="isActive('/profile/settings')">
          <span class="icon-i-person"></span>{{ 'profile.settings' | translate }}
        </a>
        <a
          *ngIf="(currentAccount?.kind !== 'kid' && customer.temporary_accounts.length) || customer.has_crowd_investor_account"
          [class.active]="isActive('/profile/documents')"
          (click)="goTo('/profile/documents')"
        >
          <span class="icon-i-document"></span>{{ 'profile.docs' | translate }}
        </a>
        <a
          *ngIf="!customer.inyova_pro && currentAccount?.kind !== 'grow'"
          (click)="goTo('/tell-friend'); trackActivity('[Link] Invite friends from navigation dropdown menu')"
          [class.active]="isActive('/tell-friend')"
        >
          <span class="icon-i-people"></span>{{ 'nav.tell_friend' | translate }}
        </a>
      </div>
      <div>
        <h4>{{ 'nav.help' | translate }}</h4>
        <a (click)="openFAQ()"><span class="icon-i-question"></span>FAQ</a>
        <a (click)="goTo('/help')" [class.active]="isActive('/help')"> <span class="icon-i-phone"></span>{{ 'nav.contact' | translate }} </a>
        <a (click)="logout()"><span class="icon-i-logout"></span>{{ 'profile.logout' | translate }}</a>
      </div>
    </div>
  </li>
</ul>

<app-dialog-generating-spinner *ngIf="switchAccountSpinner" [title]="switchAccountSpinnerMessage" [showNav]="true"> </app-dialog-generating-spinner>
